import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=46a88b29&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=46a88b29&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a88b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a88b29')) {
      api.createRecord('46a88b29', component.options)
    } else {
      api.reload('46a88b29', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=46a88b29&scoped=true", function () {
      api.rerender('46a88b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotFound.vue"
export default component.exports